import { s, type Schema, type output } from '@w/schema'

export const learnerPromptTypeCodes = { 'short-answer': 0, 'long-answer': 1, 'single-choice': 2, 'multiple-choice': 3, cloze: 4, 'spoken-response': 5 } as const
export const learnerPromptTypes = ['short-answer', 'long-answer', 'single-choice', 'multiple-choice', 'cloze', 'spoken-response'] as const
export type LearnerPromptType = typeof learnerPromptTypes[number]
const attributeFields = { importance: s.enum(['low', 'medium', 'high']), difficulty: s.enum(['low', 'medium', 'high']), promptType: s.enum(learnerPromptTypes) }
const attributes = exact(s.object(attributeFields))
const schedule = exact(s.object({ stage: s.number().int().min(0), repeatAt: s.number(), ttaSeconds: s.number().int().min(0), graduated: s.boolean() }))
const id = s.string().min(1)
const patch = exact(s.object({ importance: attributeFields.importance.optional(), difficulty: attributeFields.difficulty.optional(), promptType: attributeFields.promptType.optional() }))

/** Append-only review history; no ordering clock or card state reconstruction. */
export const reviewEventSchema = exact(s.object({ eventId:id,occurredAt:s.number(),score:s.union([s.literal(0),s.literal(1)]),durationSeconds:s.number().min(0),attributes, result:schedule }))
export type ReviewEvent = output<typeof reviewEventSchema>
export type LearnerAction =
  | ({kind:'reviewed'} & Omit<ReviewEvent,'eventId'|'occurredAt'|'attributes'>)
  | {kind:'rated';patch:output<typeof patch>}
  | {kind:'frozen';frozenAt:number|null}
  | {kind:'resolved'}
function exact<T>(schema: Schema<T> & { shape: object }): Schema<T> {
  return s.custom<T>(value => value !== null && typeof value === 'object' && !Array.isArray(value)
    && Object.keys(value).every(key => Object.hasOwn(schema.shape, key)) && schema.safeParse(value).success, 'Invalid review data')
}
